class UserHomeController {

    constructor(
        CurrentUser,
        appConfig
    ){
        'ngInject';

        this.CurrentUser = CurrentUser;
        this.appConfig = appConfig;
    }

    $onInit() {
        this.showUserAdminHome = this.CurrentUser.isUserAdmin();
        this.showClientAdminHome = this.CurrentUser.isClientAdmin();
        this.showFacilityAdminHome = this.CurrentUser.isFacilityAdmin();
        this.adminLinks = [
            {
                text: 'User Admin',
                url: 'app.user-admin',
                hideLink: !this.showUserAdminHome
            },
            {
                text: 'Client Admin',
                url: 'app.client-admin',
                hideLink: !this.showClientAdminHome
            },
            {
                text: 'Site ID Lookup',
                url: 'app.site-lookup',
                hideLink: !this.showClientAdminHome
            }
        ];

        this.facilityLinks = [
            {
                text: 'Enter Facility Data',
                url: 'app.enter-data'
            },
            {
                text: 'Enter Virtual Data',
                url: 'app.enter-virtual-data'
            },
            {
                text: 'Facility Reporting',
                url: 'app.facility-reporting.client-select'
            },
        ];
    }

}

export default UserHomeController;



// WEBPACK FOOTER //
// ./app/components/home/user-home/user-home-controller.js